import React from "react";
import moment from "moment";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";
const getSignoffHeading = (readinessData = {}) => {
  const contents = readinessData.heading_contents && typeof readinessData.heading_contents === "object"
    ? readinessData.heading_contents
    : {};
  return typeof contents.rescue_readiness_staff_signoff === "string"
    ? contents.rescue_readiness_staff_signoff
    : "";
};

const EditHeadingButton = ({ onClick, title, disabled }) => (
  <button
    type="button"
    className={`${styles.PreviewHeadingEditButton} ${disabled ? styles.PreviewHeadingEditButtonDisabled : ""}`.trim()}
    onClick={onClick}
    title={title}
    aria-label={title}
    disabled={disabled}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className={styles.EditIcon} style={{ height: "14px" }}>
      <path fill="currentColor" d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z" />
    </svg>
  </button>
);

const formatSignedAt = (signedAt) => {
  if (!signedAt) {
    return "";
  }

  return moment.utc(signedAt).isValid() ? moment.utc(signedAt).format("DD/MM/YYYY") : "";
};

const getParticipantName = (submission = {}) => {
  if (submission.added_on_the_fly && submission.added_person_name) {
    return submission.added_person_name;
  }

  return submission.staff_name || "";
};

const getParticipantRole = (submission = {}) => {
  if (submission.added_on_the_fly && submission.added_person_role) {
    return submission.added_person_role;
  }

  return submission.job_title || submission.staff_role || "";
};

const getParticipantPhone = (submission = {}) => {
  if (submission.added_on_the_fly && submission.added_person_phone) {
    return submission.added_person_phone;
  }

  return submission.phone_number || submission.staff_phone || "";
};

const getParticipantSignature = (submission = {}) => {
  return submission.signature && submission.signature.sign_url
    ? submission.signature.sign_url
    : "";
};

export default function ReadinessSignOff({ readinessData, onEditHeading, disableHeadingEdit = false }) {
  const readinessQuestions = readinessData && readinessData.rescue_readiness_questions
    ? readinessData.rescue_readiness_questions
    : readinessData || {};
  const signOffHeadingContent = getSignoffHeading(readinessQuestions) || null;
  const supervisorSubmission = readinessQuestions.shift_answers
    ? readinessQuestions.shift_answers.supervisor_submission || null
    : null;
  const workerSubmissions = readinessQuestions.shift_answers && Array.isArray(readinessQuestions.shift_answers.worker_submissions)
    ? readinessQuestions.shift_answers.worker_submissions
    : [];
  const signatoryRows = [
    ...(supervisorSubmission ? [supervisorSubmission] : []),
    ...workerSubmissions
  ];

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview} ${styles.readinessSectionNum || ""}`.trim()}>4</span>
        Rescue Readiness Sign Off
      </div>
      <div className={styles.PreviewSectionBody}>
        <div className={styles.PreviewEditableHeading}>
          <div className={`${styles.PreviewRichText} preview-swms-v3-authorization-rich-text`} dangerouslySetInnerHTML={{ __html: signOffHeadingContent || "" }} />
          <EditHeadingButton onClick={onEditHeading} title="Edit Rescue Readiness Sign Off Heading" disabled={disableHeadingEdit} />
        </div>
        <table className={styles.PreviewTable}>
          <thead>
            <tr>
              <th>Date</th>
              <th>Name</th>
              <th>Role</th>
              <th>Phone</th>
              <th>Signature</th>
            </tr>
          </thead>
          <tbody>
            {signatoryRows.length > 0 ? signatoryRows.map((submission, index) => {
              const signatureUrl = getParticipantSignature(submission);

              return (
                <tr key={`${submission && submission.staff_id ? submission.staff_id : "submission"}-${index}`}>
                  <td>{formatSignedAt(submission && submission.signed_at) || <span>&mdash;</span>}</td>
                  <td><strong>{getParticipantName(submission) || <span>&mdash;</span>}</strong></td>
                  <td style={{ textTransform: "capitalize" }}>{getParticipantRole(submission) || <span>&mdash;</span>}</td>
                  <td>{getParticipantPhone(submission) || <span>&mdash;</span>}</td>
                  <td>
                    {signatureUrl ? (
                      <img style={{ maxWidth: "auto", objectFit: "contain", maxHeight: "20px" }} src={signatureUrl} alt="Signature" />
                    ) : (
                      <span>&mdash;</span>
                    )}
                  </td>
                </tr>
              );
            }) : (
              <tr>
                <td colSpan={5}>
                  <span>No sign-off submissions recorded.</span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
